import React, { useState } from "react";

export default function QuickAgentDeleteRequest() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const primaryColor = "rgba(35, 5, 75, 1)";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch(
        "https://server-quick-agent.onrender.com/auth/request_delete_account",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus(
          "Request submitted. Please check your email to complete the deletion process."
        );
      } else {
        setStatus(data.error || "An error occurred.");
      }
    } catch (error) {
      setStatus("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f2f2f7",
      padding: "20px",
      fontFamily: "Arial, sans-serif",
    },

    card: {
      backgroundColor: "#fff",
      padding: "30px",
      borderRadius: "12px",
      width: "100%",
      maxWidth: "420px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      border: "1px solid #e5e5e5",
    },

    heading: {
      fontSize: "22px",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "15px",
      color: primaryColor,
    },

    subText: {
      textAlign: "center",
      fontSize: "14px",
      color: "#555",
      marginBottom: "20px",
    },

    label: {
      fontSize: "15px",
      marginBottom: "6px",
      fontWeight: "500",
      color: "#333",
    },

    input: {
      width: "100%",
      padding: "10px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "15px",
      marginBottom: "16px",
      outline: "none",
    },

    button: {
      width: "100%",
      padding: "10px",
      backgroundColor: primaryColor,
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      fontSize: "16px",
      cursor: "pointer",
      padding: "20px 20px",
      transition: "0.3s ease",
    },

    status: {
      textAlign: "center",
      marginTop: "15px",
      fontSize: "14px",
      color: primaryColor,
      fontWeight: "bold",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>Delete Your Quick Agent Account</h1>
        <p style={styles.subText}>
          Enter your email and password to request account deletion.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />

          <label style={styles.label}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Processing..." : "Submit Request"}
          </button>
        </form>

        {status && <p style={styles.status}>{status}</p>}
      </div>
    </div>
  );
}
